"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DietaryClassificationType = void 0;
var DietaryClassificationType;
(function (DietaryClassificationType) {
    DietaryClassificationType["Vegan"] = "VEGAN";
    DietaryClassificationType["Vegetarian"] = "VEGETARIAN";
    DietaryClassificationType["NonVegetarian"] = "NON_VEGETARIAN";
    DietaryClassificationType["Egg"] = "EGG";
    DietaryClassificationType["Kosher"] = "KOSHER";
    DietaryClassificationType["Halal"] = "HALAL";
})(DietaryClassificationType = exports.DietaryClassificationType || (exports.DietaryClassificationType = {}));
